export const painSliderCopyIt = {
    scoringHint:
        "Si fidi della Sua prima impressione - scelga il numero che corrisponde a ciò che sente in questo momento. Non è necessario rifletterci troppo a lungo.",
};
